<script>
	import { CodeSnippet } from '@shopboxai/sb-portal-components';

	import { slide } from 'svelte/transition';
	export let value;
	export let disabled = '';
	let btnName = 'Show embed code';
	let btnNameOpen = 'Hide embed code';
	let coptBtnText = 'Copy embed code';
	let isOpen = false;
	const toggle = () => (isOpen = !isOpen);
	const copyToClipboard = (text) => {
		coptBtnText = 'Copied!';
		let temp = document.createElement('textarea');
		temp.value = text;
		document.body.appendChild(temp);
		temp.select();
		document.execCommand('copy');
		document.body.removeChild(temp);
		setTimeout(() => {
			coptBtnText = 'Copy embed code';
		}, 2000);
	};
</script>

<button on:click={toggle} aria-expanded={isOpen} class={disabled}
	>{isOpen ? btnNameOpen : btnName}
	<svg
		width="12"
		height="12"
		fill="none"
		stroke-linecap="round"
		stroke-linejoin="round"
		stroke-width="2"
		viewBox="0 0 24 24"
		stroke="currentColor"
		><path d="M9 5l7 7-7 7" />
	</svg>
</button>
{#if isOpen}
	<span on:click={toggle} on:keypress={toggle} />
	<div class="embed-code" transition:slide={{ duration: 300 }}>
		<CodeSnippet language="html" code={value} />

		<button on:click={() => copyToClipboard(value)}>{coptBtnText}</button>
	</div>
{/if}

<style>
	button {
		border-top: 1px solid #d0d0d2;
		background: var(--bg-c);
		display: block;
		width: 100%;
		text-align: center;
		color: var(--h-c);
		font-size: 1rem;
		cursor: pointer;
		padding-bottom: 0.5em;
		padding-top: 0.5em;
		border-bottom-right-radius: 4px;
		border-bottom-left-radius: 4px;
		position: relative;
		z-index: 343;
	}
	.disabled {
		display: none;
		pointer-events: none;
		color: var(--bg-c);
	}
	.disabled > svg {
		display: none;
	}
	svg {
		transform: rotate(0.25turn);
		transition: transform 0.2s ease-in;
	}

	[aria-expanded='true'] svg {
		transform: rotate(0.75turn);
	}

	textarea {
		resize: none;
		width: 100%;
		min-height: 220px;
		display: block;
		border: 1px solid #d0d0d2;
		border-radius: 3px;
	}
	.embed-code :global(.codeblock) {
		overflow: scroll;
	}
	.embed-code {
		padding: 0 1em 1em;
		background-color: var(--bg-c);
		/* position: absolute; */
		z-index: 3;
		/* bottom: 0; */
		/* transform: translateY(100%); */
		width: 100%;
		border-bottom-right-radius: 4px;
		border-bottom-left-radius: 4px;
	}
	span {
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(255, 255, 255, 0);
		z-index: 3;
	}
</style>
